import request from "../config/network/requestFinalCoursewareApiService";

// 获取素材分类集合
export function queryResourceTypes() {
  return request({
    url: `resource/second_version/get_types`,
    method: "get",
  });
}

// 新增素材分类
export function addResourceType({ name, parent_type_id }) {
  return request({
    url: `resource/second_version/add_type`,
    method: "post",
    data: { name, parent_type_id },
  });
}

// 素材移动
export function moveResource({ id, type_id }) {
  return request({
    url: `resource/second_version/move_courseware_resource/${id}/${type_id}`,
    method: "put",
    data: { id, type_id },
  });
}

// 获取单元列表
export function queryUnitList() {
  return request({
    url: `unit`,
    method: "get",
  });
}

// 获取辅师闪卡列表
export function queryFlashCard(params) {
  return request({
    url: `flash_card/index`,
    method: "get",
    params,
  });
}

// 新增辅师闪卡
export function addFlashCard({
 resource_id, subject_id, structure_id, unit_id, structure_id_str,
}) {
  return request({
    url: `flash_card/store`,
    method: "post",
    data: {
 resource_id, subject_id, structure_id, unit_id, structure_id_str,
},
  });
}

// 批量新增辅师闪卡
export function addMulFlashCard(data) {
  return request({
    url: `flash_card/batch_store`,
    method: "post",
    data: { data },
  });
}

// 移除辅师闪卡
export function deleteFlashCard({ id }) {
  return request({
    url: `flash_card/delete/${id}`,
    method: "delete",
  });
}

// 移动辅师闪卡
export function moveFlashCard({ id, unit_id }) {
  return request({
    url: `flash_card/move/${id}/${unit_id}`,
    method: "put",
  });
}

// 编辑辅师闪卡
export function editFlashCard({ id, name }) {
  return request({
    url: `flash_card/update/${id}`,
    method: "put",
    data: { name },
  });
}

// 获取标签集合
export function getTags() {
  return request({
    url: `resource/tag/get_tags`,
    method: "get",
  });
}
// 获取标签集合
export function getTagsById({ resource_id }) {
  return request({
    url: `resource/tag/get_tags/${resource_id}`,
    method: "get",
  });
}
// 编辑标签
export function updateResource({
 id, new_file_name, tag_parent_id, tag_id, type, ...params
}) {
  return request({
    url: `resource/${id}`,
    method: "put",
    data: {
 is_tag: 1, new_file_name, tag_parent_id, tag_id, type, ...params,
},
  });
}

